/**
 *  All api related to Coupons
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchCoupons(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCoupons',
    () => source.cancel('fetchCoupons: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'coupons',
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      coupons: _.get(data, 'coupons', {}),
      next: _.get(data, 'couponsPagination.nextPage') > page
        ? () =>
          fetchCoupons({
            page: page + 1,
            ...others
          })
        : null,
      count: _.get(data, 'couponsPagination.totalCount')
    }))
}

export function fetchCoupon({ id, ...params }) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCoupon',
    () => source.cancel('fetchCoupon: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `coupons/${id}`,
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      coupon: _.get(data, 'coupon', {})
    }))
}

export function fetchCouponPublicShow({ id, ...params }) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCouponPublicShow',
    () => source.cancel('fetchCouponPublicShow: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `coupons/${id}/public_show`,
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      coupon: _.get(data, 'coupon', {})
    }))
}
